import { format } from 'date-fns';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject } from 'Mri.Web.Common';
import * as React from 'react';
import { BsDisplay } from '@react-icons/all-files/bs/BsDisplay';
import { BsPhone } from '@react-icons/all-files/bs/BsPhone';
import { BsTv } from '@react-icons/all-files/bs/BsTv';

export interface IDeviceLoginItemProps {
    readonly logItem: Mri.Audit.AuditLog<Mri.Audit.UserSessionLog>;
}

@autoinject
@observer
export class DeviceLoginItem extends React.Component<IDeviceLoginItemProps> {
    public render() {
        const { logItem } = this.props;
        return (
            <div className="row mb-2">
                <div className="col-6">
                    <div className="icon-circle text-white">{this.icon}</div>

                    <span className="px-2">{logItem.payload.device}</span>
                </div>
                <div className="col-6 d-flex align-items-center">
                    {format(logItem.payload.timeStamp, 'EEEE, MMMM do yyyy, h:mm:ss a')}
                </div>
            </div>
        );
    }

    @computed
    private get icon() {
        switch (this.props.logItem.payload.device) {
            default:
                return <BsDisplay />;
            case 'Android':
                return <BsPhone />;
            case 'BlackBerry OS':
                return <BsPhone />;
            case 'Chrome OS':
                return <BsTv />;
            case 'GoogleTV':
                return <BsTv />;
            case 'iOS':
                return <BsPhone />;
            case 'Mac OS X':
                return <BsTv />;
            case 'PCLinuxOS':
                return <BsDisplay />;
            case 'Windows Phone':
                return <BsPhone />;
            case 'Windows':
                return <BsTv />;
        }
    }
}
